import CollapseCategories32 from '@carbon/icons-react/es/collapse-categories/32';
import ExpandCategories32 from '@carbon/icons-react/es/expand-categories/32';
import { Menu, Typography } from 'antd';
import { Link as RouterLink } from 'react-router-dom';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import {
  BodyShort01,
  SingleLineEllipsis,
  Text02,
  Text03,
} from 'components/styles';

export const SpaceMenuTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const AddButton = styled(Button)`
  height: var(--height-base);

  &:active,
  &:hover,
  &:focus {
    color: var(--primary-color);
  }
  &:active {
    background: none !important;
  }

  svg {
    margin-right: 0;
  }
`;

export const StyledCollapseIcon = styled(CollapseCategories32)`
  width: 16px;
  height: 16px;
`;

export const StyledExpandIcon = styled(ExpandCategories32)`
  width: 16px;
  height: 16px;
`;

export const MenuItemWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 170px;
`;

export const Link = styled(RouterLink)`
  flex: 1;
  ${SingleLineEllipsis};
`;

export const Empty = styled(Typography.Text)`
  padding: 6px 0 6px 80px;
  ${BodyShort01};
  ${Text03};
`;

export const MenuItem = styled(Menu.Item)`
  .more-actions {
    opacity: 0;
    transition: opacity 50ms ease-in;
  }
  .more-actions:focus-within {
    opacity: 1;
  }

  &:hover {
    .more-actions {
      opacity: 1;
    }
  }
`;

export const Loader = styled.div`
  padding: var(--spacing-05);
  padding-left: var(--spacing-09);
  ${Text02};
`;
